import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router";
import {
  ArrowRightStartOnRectangleIcon,
  CameraIcon,
  GiftIcon,
  GlobeAltIcon,
  SparklesIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";

import Button from "../../atoms/Button";
import HeaderModal from "./HeaderModal";
import { useAuth } from "../../../hooks/useAuth";
import { useUserStore } from "../../../store/userStore";
import MobileNavEntry from "./MobileNavEntry";
import InboxNotifications from "../../molecules/notifications/InboxNotifications";
import GeneralNotifications from "../../molecules/notifications/GeneralNotifications";

function HeaderMobile({ routes }: { routes: any[] }) {
  const user = useUserStore((state) => state.user);
  const { logout } = useAuth();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAccount, setIsOpenAccount] = useState(false);
  const [isOpenMessages, setIsOpenMessages] = useState(false);
  const [isOpenNotifications, setIsOpenNotifications] = useState(false);

  return (
    <header>
      <Link
        to="#main-content"
        className="z-50 block sr-only focus:not-sr-only bg-surface-base !px-2 !py-1 rounded-2xl !absolute top-2 left-2 focus:ring focus:ring-blue-500"
        onClick={() => {
          document.getElementById("main-content")?.focus();
        }}
      >
        Skip to main content
      </Link>
      <div
        className={`bg-surface-base min-[1024px]:hidden max-md:fixed max-md:top-0 max-md:z-15 max-md:w-full ${
          (isOpen || isOpenNotifications) &&
          "fixed top-0 left-0 w-full h-[100vh] overflow-y-auto z-20"
        }`}
      >
        <div className="p-3 flex items-center gap-2">
          <div>
            <Button
              style="tertiary"
              className="flex bg-surface-base shadow-md hover:shadow-lg rounded-xl p-4"
              aria-label={isOpen ? "Close navigation" : "Open navigation"}
              aria-expanded={isOpen}
              onClick={() => {
                setIsOpen(!isOpen);
                setIsOpenAccount(false);
                setIsOpenMessages(false);
                setIsOpenNotifications(false);
              }}
            >
              {isOpen ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 13L13 1M1 1L13 13"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H1C0.447715 2 0 1.55228 0 1ZM0 7C0 6.44772 0.447715 6 1 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H1C0.447715 8 0 7.55228 0 7ZM0 13C0 12.4477 0.447715 12 1 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H1C0.447715 14 0 13.5523 0 13Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </Button>
          </div>
          <div>
            <Link to="/">
              <img
                src={`/assets/mobileLogo.svg`}
                alt="Givin Gifts"
                width={40}
                height={40}
              />
            </Link>
          </div>
          {user ? (
            <div className="flex gap-1 ml-auto">
              <div className="text-end ml-auto">
                <InboxNotifications mobileView />
              </div>
              <div className="text-end ml-auto">
                <GeneralNotifications mobileView />
              </div>
              <div className="text-end ml-auto mr-auto">
                <button
                  className="bg-surface-base hover:bg-surface-base active:bg-surface-lowered text-text-base rounded-full shadow-sm hover:shadow-md lg:text-lg flex bg-surface-base shadow-md hover:shadow-lg rounded-xl relative h-[2.875rem] w-[2.875rem]"
                  aria-label={
                    isOpenAccount ? "Close my account" : "Open my account"
                  }
                  aria-expanded={isOpenAccount}
                  onClick={() => {
                    setIsOpen(false);
                    setIsOpenMessages(false);
                    setIsOpenNotifications(false);
                    setIsOpenAccount(!isOpenAccount);
                  }}
                >
                  <img
                    src={`https://images.givin.gifts/preset:sharp/resize:fit:720:0:0/format:webp/gravity:sm/plain/https://storage.ethereal.sh/gifts-public/${user.picture}`}
                    alt="Avatar"
                    className="w-full h-full rounded-xl aspect-square object-cover"
                  />
                </button>
              </div>
            </div>
          ) : (
            <div className="flex gap-1 ml-auto">
              <Button style="secondary" link="/register" className="">
                Register
              </Button>
              <Button style="tertiary" link="/login" className="ml-auto">
                Log in
              </Button>
            </div>
          )}
        </div>

        {isOpen && (
          <HeaderModal
            title="Navigation"
            displayModal={isOpen}
            setDisplayModal={setIsOpen}
          >
            <nav className="flex flex-col gap-5">
              {routes.map((route) => (
                <Fragment key={route.title}>
                  <MobileNavEntry route={route} setIsOpen={setIsOpen} />
                </Fragment>
              ))}
            </nav>
            {!user && (
              <>
                <div className="bg-surface-raised h-[1px] my-5">&nbsp;</div>
                <div>
                  <div>
                    <Button
                      style="secondary"
                      className="w-full justify-center"
                      link="/register"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      Register
                    </Button>
                  </div>
                  <div className="mt-2">
                    <Button
                      style="tertiary"
                      className="w-full justify-center"
                      link="/login"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      Log in
                    </Button>
                  </div>
                </div>
              </>
            )}
          </HeaderModal>
        )}

        {isOpenAccount && (
          <HeaderModal
            title="My account"
            displayModal={isOpenAccount}
            setDisplayModal={setIsOpenAccount}
          >
            <div className="flex flex-col gap-3">
              <div>
                <Link
                  to={`/account`}
                  className="group"
                  onClick={() => setIsOpenAccount(false)}
                >
                  <div className="flex items-center">
                    <div className="text-text-base text-text-secondary">
                      <UserCircleIcon className="w-5 h-5" />
                    </div>
                    <div className="ml-3 text-text-base group-hover:underline">
                      My account
                    </div>
                  </div>
                </Link>
              </div>
              {user && user.nickname && user.nickname !== "" && (
                <div>
                  <Link
                    to={`/profile/${user.nickname}`}
                    className="group"
                    onClick={() => setIsOpenAccount(false)}
                  >
                    <div className="flex items-center mt-5">
                      <div className="text-text-base text-text-secondary">
                        <GlobeAltIcon className="w-5 h-5" />
                      </div>
                      <div className="ml-3 text-text-base group-hover:underline">
                        My profile
                      </div>
                    </div>
                  </Link>
                </div>
              )}
              <div>
                <Link
                  to={`/exchanges/my-exchanges`}
                  className="group"
                  onClick={() => setIsOpenAccount(false)}
                >
                  <div className="flex items-center mt-5">
                    <div className="text-text-base text-text-secondary">
                      <GiftIcon className="w-5 h-5" />
                    </div>
                    <div className="ml-3 text-text-base group-hover:underline">
                      My exchanges
                    </div>
                  </div>
                </Link>
              </div>

              <div>
                <Link
                  to={`/gallery/my-posts`}
                  className="group"
                  onClick={() => setIsOpenAccount(false)}
                >
                  <div className="flex items-center mt-5">
                    <div className="text-text-base text-text-secondary">
                      <CameraIcon className="w-5 h-5" />
                    </div>
                    <div className="ml-3 text-text-base group-hover:underline">
                      My posts
                    </div>
                  </div>
                </Link>
              </div>

              <div>
                <Link
                  to={`/exchanges/my-rematches`}
                  className="group"
                  onClick={() => setIsOpenAccount(false)}
                >
                  <div className="flex items-center mt-5">
                    <div className="text-text-base text-text-secondary">
                      <SparklesIcon className="w-5 h-5" />
                    </div>
                    <div className="ml-3 text-text-base group-hover:underline">
                      My rematches
                    </div>
                  </div>
                </Link>
              </div>
              <div>
                <Link
                  to={`#`}
                  className="group"
                  onClick={() => {
                    setIsOpenAccount(false);
                    logout();
                  }}
                >
                  <div className="flex items-center mt-5">
                    <div className="text-text-base text-text-secondary">
                      <ArrowRightStartOnRectangleIcon className="w-5 h-5" />
                    </div>
                    <div className="ml-3 text-text-base group-hover:underline">
                      Log out
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </HeaderModal>
        )}
      </div>
    </header>
  );
}

export default HeaderMobile;
